import styled, { css } from 'styled-components';

import { scale005, xdlColorLink, xdlColorLinkHover } from '@xing-com/tokens';

// *** Base ***
const baseMention = css`
  color: ${xdlColorLink};
  text-decoration: none;
`;

// *** Components ***
const EditorMention = styled.span`
  ${baseMention}
`;

const ViewerMention = styled.a`
  ${baseMention}

  &:hover,
  &:active,
  &:focus {
    border-bottom: ${scale005} solid ${xdlColorLinkHover};
    color: ${xdlColorLinkHover};
    text-decoration: none;
  }
`;

export const Styled = {
  EditorMention,
  ViewerMention,
};
